import { background } from '@carvana/helios-styles';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isIOSWebView } from '../shared/nativeAppMessaging';

const BasicFooter = styled.div`
  height: 610px;
`;

const footerWrapperClassName = 'footer-wrapper';

const Container = styled.div`
  background: #e4ecf0;
  width: 100%;

  &.nativeMobile {
    height: max-content;
    opacity: 0;
    transition: opacity 0.2s ease-in;

    .content-loaded & {
      opacity: 1;
    }
  }

  .${footerWrapperClassName} {
    background-color: ${background.weak};
  }
`;

const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
`;

const Footer = () => {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'FooterModule',
          [
            {
              component: 'default',
              browser: true,
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CARVANA_APP_CDN_URL
                }/footer/module/assets-manifest.json?v=${Date.now()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const [nativeMobile, setNativeMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'object') {
      const isIOS = isIOSWebView();
      setNativeMobile(isIOS);
    }
  }, []);

  return (
    <Container className={classnames({ nativeMobile })}>
      <Inner>
        <MfeReactComponent component="default" module="FooterModule" loading={<BasicFooter />}>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {({ Component: FooterComponent }: any) => (
            <FooterComponent
              environment={process.env.CARVANA_APP_ENVIRONMENT}
              withoutProvider
              wrapperClassName={footerWrapperClassName}
            />
          )}
        </MfeReactComponent>
      </Inner>
    </Container>
  );
};

export default Footer;
